<template>
  <section
    class="preventa-ninety-days"
    aria-labelledby="preventa-ninety-days-title"
  >
    <header class="preventa-ninety-days__header">
      <DsTextSplit
        id="preventa-ninety-days-title"
        as="h3"
        base="¿Qué sucede durante esos"
        highlight="90 días?"
        base-color="var(--ds-purple-900)"
        highlight-color="var(--ds-purple-400)"
        class="preventa-ninety-days__title"
      />

      <DsText as="body3" class="preventa-ninety-days__description">
        Tu camino está dividido en etapas claras. Aquí puedes entender en cuál
        estás y qué sigue:
      </DsText>
    </header>

    <div class="preventa-ninety-days__outcomes">
      <DsIconList
        title="Si entregas la documentación antes"
        title-id="preventa-early-documents-title"
        :icon-src="successIcon"
        :items="successItems"
      />

      <DsIconList
        title="Si no entregas la documentación"
        title-id="preventa-missing-documents-title"
        :icon-src="warningIcon"
        :items="warningItems"
      />
    </div>

    <div class="preventa-ninety-days__restrictions">
      <DsIconList
        title="RESTRICCIONES IMPORTANTES"
        title-id="preventa-restrictions-title"
        :icon-src="restrictionIcon"
        :items="restrictionItems"
        class="preventa-ninety-days__restrictions-list"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import restrictionIcon from '../../../../../assets/preventa/Vector (2).svg'
import successIcon from '../../../../../assets/preventa/check_circle_24dp_E3E3E3_FILL1_wght400_GRAD0_opsz24 3.svg'
import warningIcon from '../../../../../assets/preventa/warning_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24 1.svg'
import DsText from '../atoms/DsText.vue'
import DsTextSplit from '../atoms/DsTextSplit.vue'
import DsIconList from '../components/DsIconList.vue'

const successItems = [
  {
    id: 'adjudication-process',
    text: 'Inicia tu proceso de adjudicación'
  },
  {
    id: 'mandatory-fees',
    text: 'Se detienen las cuotas obligatorias'
  }
]

const warningItems = [
  {
    id: 'monthly-payments',
    text: 'Deberás comenzar a pagar mensualidades'
  },
  {
    id: 'collection-process',
    text: 'Tu cuenta puede entrar a proceso de cobranza'
  }
]

const restrictionItems = [
  {
    id: 'legal-entities',
    text: 'No se aceptan anticipos de personas morales'
  },
  {
    id: 'branch-cash',
    text: 'No recibimos dinero en sucursal'
  },
  {
    id: 'traceable-payments',
    text: 'Todos los pagos deben ser rastreables'
  },
  {
    id: 'committee-approval',
    text: 'La operación está sujeta a aprobación del Comité'
  }
]
</script>

<style scoped>
.preventa-ninety-days,
.preventa-ninety-days__header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.preventa-ninety-days {
  gap: 32px;
  width: 100%;
}

.preventa-ninety-days__header {
  gap: 8px;
  width: 100%;
}

.preventa-ninety-days__title {
  min-height: 56px;
  font-size: var(--ds-h3-size);
  font-weight: var(--ds-h3-weight);
  line-height: 44px;
}

.preventa-ninety-days__description {
  max-width: 100%;
  color: var(--ds-text-primary);
  line-height: 24px;
}

.preventa-ninety-days__outcomes {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 24px;
  width: 100%;
  padding: 16px;
  box-sizing: border-box;
  background: var(--ds-grey-50);
  border-radius: 24px;
}

.preventa-ninety-days__restrictions {
  width: 100%;
  padding: 24px 16px;
  box-sizing: border-box;
  background: var(--ds-grey-50);
  border-radius: 24px;
}

.preventa-ninety-days__restrictions-list :deep(.ds-icon-list__items) {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 8px;
}

.preventa-ninety-days__restrictions-list {
  gap: 24px;
}

.preventa-ninety-days__restrictions-list :deep(.ds-icon-list__title) {
  min-height: auto;
}

.preventa-ninety-days__restrictions-list :deep(.ds-icon-list__item) {
  min-height: 40px;
}

.preventa-ninety-days__restrictions-list :deep(.ds-icon-list__icon) {
  width: 10px;
  height: 10px;
}

@media (min-width: 768px) {
  .preventa-ninety-days__outcomes {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .preventa-ninety-days__restrictions-list :deep(.ds-icon-list__items) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>
